import React from "react";
import {cx} from "../../lib/ClassSet";
import {Link} from "react-router";
import "./OrderItem.css";
import format from 'date-fns/format'
import {formatSalesOrderStatus} from "../../lib/SalesOrderStatus";
import ContextMenuTrigger from "../../components/ContextMenuTrigger";
import {DiscountedTag, GiftTag, NewSubscriptionTag, OneTimeOrderTag, SubscriptionTag} from "../../components/MiniTag";


const OrderItem = (props) => {

  let {data} = props;
  
  const isGift = data.get("gift") === true;
  const isDiscounted = data.get("promoCodeApplied") === true;
  const isSubscription = data.get("source") === "subscription";
  const isNewsubscription = data.get("source") === "checkout" && data.get("subscription") === true;
  const isOnetime = data.get("source") === "checkout" && data.get("subscription") === false;

  let classes = cx({
    "item": true,
    "sales-order-list-item": true,
    "u-paid": data.get("billingStatus") === "paid",
    "u-gift": isGift,
    "u-discounted": isDiscounted,
    "u-subscription": isSubscription,
    "u-newsubscription": isNewsubscription,
    "u-onetime": isOnetime,
  })

  let invoiceNr = (data.get("invoiceNr") === "") ? data.get("orderId") : data.get("invoiceNr");
  let total = `${data.get("total")} ${data.get("currency")}`;
  let paidField = (data.get("billingStatus") === "paid") ? format(data.get("paidAt"), "MMM D, YYYY") : "--";
  let contextClickFn = () => props.onContextMenuClick(data.get("orderId"))
  
  return (
    <tr className={classes}>
      <td className="field f-id"><Link to={`/sales/orders/${data.get("orderId")}`}>{invoiceNr}</Link></td>
      <td className="field">{data.getIn(["billingAddress", "name"])}</td>
      <td className="field">{format(data.get("createdAt"), "MMM D, YYYY")}</td>
      <td className="field">{paidField}</td>
      <td className="field f-total">{total}</td>
      <td className="field f-fulfillment">{formatSalesOrderStatus(data.get("billingStatus"))}</td>
      <td className="field f-x">
        <SubscriptionTag show={isSubscription} />
        <NewSubscriptionTag show={isNewsubscription} />
        <OneTimeOrderTag show={isOnetime} />
        <GiftTag show={isGift} />
        <DiscountedTag show={isDiscounted} />
      </td>
      <td className="field f-context"><ContextMenuTrigger active={true} onClick={contextClickFn}/></td>
    </tr>
  )
}

export default OrderItem;